<template>
  <div v-if="is_open">
    <div class="embed-video-overlay">
      <div class="embed-video-container">
        <div class="embed-video-container__header">
            <h5 class="position-relative">
                <template v-if="type == 'add'">{{ $t('components.embed_video.embed_video') }}</template>
                <template v-else>{{ $t('components.embed_video.edit_embed_video') }}</template>
            </h5>
        </div>

        <div class="embed-video-container__body">
            <div class="input-group">
                <input type="text" name="title" placeholder="https://www.youtube.com/watch?v=mhUTzvVN284" class="input" v-model="url" @keydown="validateVideoQuality" @change="validateVideoQuality" @input="validateVideoQuality">
                <label for="title" class="subtitle text-primary">
                    <template v-if="type == 'add'">{{ $t('components.embed_video.add_video_link') }}</template>
                    <template v-else>{{ $t('components.embed_video.edit_video_link') }}</template>
                </label>
            </div>
            <template v-if="hero">
                <div class="embed-video-container__checkbox-wrap">
                    <a-checkbox @change="as_hero = arguments[0].target.checked"><span class="text-primary subtitle">{{ $t('components.embed_video.as_top_section_cover') }}</span></a-checkbox>
                    <help-popup :title="$t('listing_form.help_popup.as_top_section_cover_title')" :description="$t('listing_form.help_popup.as_top_section_cover_description')" image="/img/help-preview/as-hero-video.png"></help-popup>
                </div>
            </template>
            <div class="embed-video-container__hd-wrap" v-if="show_hd == true">
                <label for="show_hd" class="subtitle text-primary">{{ $t('components.embed_video.hd_quality') }}</label>
                <a-switch v-model="is_hd"></a-switch>
            </div>
        </div>

        <div class="embed-video-container__footer d-flex">
            <button class="ml-auto button button-m button-secondary mr-16" @click.prevent="clear()">{{ $t('common.cancel') }}</button>
            <button class="button button-m button-primary" @click.prevent="embedVideo()">{{ $t('common.save') }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
        props: {
            listing_id: {
                default: null,
                type: Number
            }
        },
        data() {
            return {
                hero: false,
                is_open: false,
                column: null,
                url: "",
                type: "",
                as_hero: false,
                show_hd: false,
                is_hd: true,
            }
        },
        mounted() {

        },
        methods: {
            clear() {
                this.is_open = false;
                this.column = null;
                this.url = "";
                this.type = "";
                this.show_hd = false
                this.is_hd = true
            },
            validateVideoQuality() {
                let videoUrl = this.url

                this.show_hd = ((/^(http\:\/\/|https\:\/\/)?(www\.)?(vimeo\.com\/)([0-9]+)$/).test(videoUrl))
            },
            embedVideo() {
                let url = `/api/media/embed-video/${this.listing_id}`;

                return axios.post(url, {
                    column: this.column,
                    url: this.url,
                    as_hero: this.as_hero,
                    is_hd: this.is_hd,
                }).then(function (response) {
                    this.$root.$emit('video_embedded', this.column, response.data.data.embedded_video);

                    if (this.as_hero) {
                        this.$root.$emit('video_embedded', 'hero_media', response.data.data.embedded_video);
                    }

                    this.clear();
                    this.$toastr.success(this.$t('components.embed_video.video_embedded'));
                }.bind(this))
                .catch(error => {
                    this.$toastr.error(this.$t('components.embed_video.failed_to_embed_video'));
                })
            }
        },
        watch: {
        }
    }
</script>
